import { render, staticRenderFns } from "./NewsSideMenu.vue?vue&type=template&id=7a9ee0d8"
import script from "./NewsSideMenu.ts?vue&type=script&lang=ts&external"
export * from "./NewsSideMenu.ts?vue&type=script&lang=ts&external"
import style0 from "./NewsSideMenu.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports